/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Forms_TitleInputs */

const en_pc_tut_forms_title = /** @type {(inputs: Pc_Tut_Forms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fill forms and add comments`)
};

const zh_pc_tut_forms_title = /** @type {(inputs: Pc_Tut_Forms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`填写表单与添加批注`)
};

/**
* | output |
* | --- |
* | "Fill forms and add comments" |
*
* @param {Pc_Tut_Forms_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_forms_title = /** @type {((inputs?: Pc_Tut_Forms_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Forms_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_forms_title(inputs)
	return zh_pc_tut_forms_title(inputs)
});
export { pc_tut_forms_title as "pc.tut.forms.title" }